import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import _ from "lodash";
import moment from "moment";

import { noReduxApi } from "utils/Api";
import getToken from "utils/getToken";

const useLatestRelease = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])

  const mappingData = (_data) => _data.map(d => ({
    ...d,
    date: moment(d.release_date).format("MMMM do, YYYY"),
    display_name: d.display_name,
    imageUrl: _.get(d?.product_variant_images?.[0], "signed_url")
  }))

  const getLatestRelease = async (category) => {
    try {
      setLoading(true)
      const latestRelease = await noReduxApi(getToken()).get(`/products?sort_by=product_desc&per_page=26&category=${category}`)

      const _data = _.get(latestRelease, "data.data.data")

      setData(_data?.length ? mappingData(_data) : [])

    } catch (error) {
      console.log(error, "Failed to get latest release useLatestRelease.js")
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    data,
    getLatestRelease
  }
}

export default useLatestRelease